export enum FeesPaidByEnum {
  CUSTOMER = "CUSTOMER",
  CREATOR = "CREATOR"
}
